import classNames from 'classnames';
import React from 'react';

import {NucleotideType} from 'biojs/BioConstants';
import {Strand} from 'constants/MolbioConstants';
import {SequenceType} from 'constants/SequenceConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface CopyOptionsModalProps {
  circular: boolean;
  sourceSequenceType: SequenceType;
  strand?: Strand;
  targetNucleotideType: NucleotideType;
}

function CopyOptionsModal({
  circular,
  sourceSequenceType,
  strand,
  targetNucleotideType,
}: CopyOptionsModalProps): JSX.Element {
  const strandDisplay = strand != null ? (strand === 1 ? 'of Forward Strand ' : 'of Reverse Strand ') : '';
  return (
    <div
      tabIndex={-1}
      className="modal seltosequence-options-modal"
      {...getTestProps({component: 'CopyOptionsModalTemplate', element: 'root'})}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4>
              Copy Selection {sourceSequenceType === SequenceType.DOUBLE_STRANDED ? strandDisplay : ''}to New{' '}
              {targetNucleotideType}
            </h4>
          </div>
          <div className="modal-body">
            <p className="help-block">Customize what gets copied over:</p>
            <div className="checkbox primer-bases-wrapper">
              <label>
                <input type="checkbox" className="primer-bases" />
                Use primer bases instead of sequence (includes overhang if any)
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input type="checkbox" className="annotations" />
                Annotations, translations, and primers
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input type="checkbox" className="not-contained-annotations" />
                Include annotations and translations not fully contained by selection
              </label>
            </div>
            {strand == null && (
              <div className="checkbox">
                <label>
                  <input type="checkbox" className="reverse-complement" />
                  Use reverse complement instead
                </label>
              </div>
            )}
            <div className={classNames('checkbox', {faded: circular})}>
              <label>
                <input type="checkbox" disabled={circular} className="js-preserve-indices" />
                Preserve sequence indices
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input type="checkbox" className="tags" defaultChecked={true} />
                Tags
              </label>
            </div>
            <div className="checkbox">
              <label>
                <input type="checkbox" className="description" />
                Description
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <a data-dismiss="modal" className="btn btn-af-default">
              Cancel
            </a>
            <a
              data-dismiss="modal"
              className="btn btn-af-success copy"
              {...getTestProps({component: 'CopyOptionsModalTemplate', element: 'createButton'})}
            >
              Copy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<CopyOptionsModalProps>(CopyOptionsModal);
